/**
 * ERP相关路由配置
 * 说明：尽量只做二级路由，即（菜单+子菜单）；不用将子系统写进路由配置
 * 注意：路由名称name需要注意查重！！！ 创建路由时先确定项目中没有相同的name!!
 */
import type { AppRouteRecordRaw } from '@/router/types'

export const erpRoutes: AppRouteRecordRaw[] = [
  {
    path: 'toolsPackage',
    name: 'ToolsPackage',
    redirect: '/toolsPackage/contractTemplate',
    meta: {
      title: '工具箱'
    },
    children: [
      {
        path: 'contractTemplate',
        name: 'ContractTemplate',
        component: () => import('@/views/erp/systemManage/toolsPackage/contractTemplate/index.vue'),
        meta: {
          title: '合同模版配置',
          keepAlive: true
        }
      }
    ]
  },
  {
    path: 'contractManage',
    name: 'ContractManage',
    component: () => import('@/views/erp/base/contractManage/index.vue'),
    meta: {
      title: '合同管理',
      keepAlive: true
    }
  },
  {
    path: 'incomeOrdererp',
    name: 'IncomeOrdererp',
    component: () => import('@/views/erp/base/incomeOrder/index.vue'),
    meta: {
      title: '进件订单管理',
      keepAlive: true
    }
  },
  {
    path: 'handleOrdererp',
    name: 'HandleOrdererp',
    component: () => import('@/views/erp/base/handleOrder/index.vue'),
    meta: {
      title: '办抵工单',
      keepAlive: true
    }
  },
  {
    path: 'incomeOrderbpm',
    name: 'IncomeOrderbpm',
    component: () => import('@/views/erp/bpm/incomeOrder/index.vue'),
    meta: {
      title: '进件订单管理',
      keepAlive: true
    }
  },
  {
    path: 'handleOrderbpm',
    name: 'HandleOrderbpm',
    component: () => import('@/views/erp/bpm/handleOrder/index.vue'),
    meta: {
      title: '办抵工单',
      keepAlive: true
    }
  },

  {
    path: 'partnersManage',
    name: 'PartnersManage',
    component: () => import('@/views/erp/base/partnersManage/index.vue'),
    meta: {
      title: '合作机构管理',
      keepAlive: true
    }
  },
  {
    path: 'guaranteeManage',
    name: 'GuaranteeManage',
    component: () => import('@/views/erp/base/guaranteeManage/index.vue'),
    meta: {
      title: '担保方管理',
      keepAlive: true
    }
  },
  {
    path: 'fundManageInfo',
    name: 'FundManageInfo',
    component: () => import('@/views/erp/base/fundManageInfo/index.vue'),
    meta: {
      title: '资管明细',
      keepAlive: true
    }
  },
  {
    path: 'billManage',
    name: 'BillManage',
    component: () => import('@/views/erp/base/billManage/index.vue'),
    meta: {
      title: '账单管理',
      keepAlive: true
    }
  },
  {
    path: 'billDetail',
    name: 'BillDetail',
    component: () => import('@/views/erp/base/billManage/billDetail/index.vue'),
    meta: {
      title: '账单管理详情'
    }
  },
  {
    path: 'creditReportInquiry',
    name: 'CreditReportInquiry',
    component: () => import('@/views/erp/systemManage/toolsPackage/creditReport/index.vue'),
    meta: {
      title: '信用报告查询'
    }
  },
  {
    path: 'erp',
    name: 'ERP',
    redirect: '/erp/moneylendingManage',
    meta: {
      title: '放款管理'
    },
    children: [
      {
        path: 'productManage',
        name: 'erpProductManages',
        component: () => import('@/views/erp/base/productManage/index.vue'),
        meta: {
          title: '产品管理',
          keepAlive: true
        }
      },
      {
        path: 'moneylendingManage',
        name: 'erpMoneylendingManage',
        component: () => import('@/views/erp/base/moneylendingManage/index.vue'),
        meta: {
          title: '放款管理',
          keepAlive: true
        }
      },
      {
        path: 'moneylendingDetail/:loanId',
        name: 'erpMoneylendingDetail',
        component: () => import('@/views/erp/base/moneylendingManage/detail/index.vue'),
        meta: {
          title: '放款详情'
        }
      }
    ]
  },
  {
    path: 'bpm',
    name: 'BPM',
    redirect: '/bpm/productManage',
    meta: {
      title: '放款管理'
    },
    children: [
      {
        path: 'productManage',
        name: 'bpmProductManage',
        component: () => import('@/views/erp/bpm/productManage/index.vue'),
        meta: {
          title: '资金方产品管理',
          keepAlive: true
        }
      },
      {
        path: 'moneylendingManage',
        name: 'bpmMoneylendingManage',
        component: () => import('@/views/erp/bpm/moneylendingManage/index.vue'),
        meta: {
          title: '放款管理',
          keepAlive: true
        }
      },
      {
        path: 'moneylendingDetail/:loanId',
        name: 'bpmMoneylendingDetail',
        component: () => import('@/views/erp/bpm/moneylendingManage/detail/index.vue'),
        meta: {
          title: '放款详情'
        }
      }
    ]
  },
  {
    path: 'earlyRepayment',
    name: 'EarlyRepayment',
    component: () => import('@/views/erp/base/earlyRepayment/index.vue'),
    meta: {
      title: '提前还款管理'
    }
  },
  {
    path: 'distributionManage',
    name: 'DistributionManage',
    component: () => import('@/views/erp/base/distributionManage/index.vue'),
    meta: {
      title: '分销商管理',
      keepAlive: true
    }
  },
  {
    path: 'notarizationManage',
    name: 'NotarizationManage',
    component: () => import('@/views/erp/base/notarizationManage/index.vue'),
    meta: {
      title: '公证管理'
    }
  }
]
